import { Tooltip } from '@mui/material';
import React , {useState} from 'react'

const TooltipContent = ({handleClose}) => {
    return (
        <>
        <div style={{fontSize : '14px', fontWeight : 400}}>You can download draft summary from here.</div>
        <button className='no-ml-btn mt-1' style={{backgroundColor : '#FFF', borderRadius : '4px', fontSize : '12px', color : '#333', fontWeight : 600, padding : '4px 6px'}} onClick={handleClose}>Okay</button>
        </>
    )
}

const DraftSummaryTooltip = ({open, setOpen, children}) => {

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    return (  
        <Tooltip
         arrow 
         open={open}
         disableHoverListener
         onClose={handleClose}
         onOpen={handleOpen}
         title={<TooltipContent handleClose={handleClose}/>}
         componentsProps={{
            tooltip: {
              sx: {
                bgcolor: '#333 !important',
                width : '200px !important',
                padding : '16px !important',
                '& .MuiTooltip-arrow': {
                  color: '#333',
                },

              },
            },
          }}
         >
            <span>{children}</span>
        </Tooltip>
    );
}
 
export default DraftSummaryTooltip;